export default __webpack_public_path__ + "static/media/spaceship.32ad78c3.svg";